// extracted by mini-css-extract-plugin
module.exports = {"buttonWrap":"RadioButtons_buttonWrap__2LTaD","pText":"RadioButtons_pText__2r1uO","label":"RadioButtons_label__2C-pE","radio":"RadioButtons_radio__1UGhN"};